<div class="flex flex-column color-details-description-container">
  @if (isBestseller()) {
  <p-tag class="mb-4" [value]="bestSellerTag | resourceValue" severity="info" [icon]="primeIcons.STAR" />
  } @if(colorDescription()) {
  <p>{{ colorDescription() }}</p>
  }
</div>
